<template>
  <p>
    {{ $t('error.410.description.alreadySigned') }}
  </p>

  <p>
    {{ $t('error.410.description.contactSigner') }}
  </p>
</template>
